  /* =====================================================================
    THAIBUTIKKEN — klik-baseret forstørrelsesglas på produktbilleder
    Tilføjer en knap øverst i højre hjørne af hvert hovedbillede.
    Klik for at toggle zoom-mode. Når aktiv: billedet zoomer hvor musen er.
    ===================================================================== */
  (function () {
    'use strict';

    function initZoomToggle(li) {
      if (li.dataset.zoomReady === '1') return;
      li.dataset.zoomReady = '1';

      var img = li.querySelector('picture img');
      if (!img) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'zoom-toggle-btn';
      btn.setAttribute('aria-label', 'Aktivér forstørrelsesglas');
      btn.innerHTML =
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.5" y2="16.5"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>';

      li.appendChild(btn);

      var zoomScale = 2.2;
      var anchorLink = li.querySelector('a[data-fancybox]');

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var willActivate = !li.classList.contains('zoom-active');
        li.classList.toggle('zoom-active', willActivate);
        btn.setAttribute(
          'aria-label',
          willActivate ? 'Deaktivér forstørrelsesglas' : 'Aktivér forstørrelsesglas'
        );
        if (!willActivate) {
          resetTransform();
        }
      });

      function resetTransform() {
        img.style.transform = '';
        img.style.transformOrigin = '';
      }

      li.addEventListener('mousemove', function (e) {
        if (!li.classList.contains('zoom-active')) return;
        var rect = li.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        // Clamp 0-100
        x = Math.max(0, Math.min(100, x));
        y = Math.max(0, Math.min(100, y));
        img.style.transformOrigin = x + '% ' + y + '%';
        img.style.transform = 'scale(' + zoomScale + ')';
      });

      li.addEventListener('mouseleave', function () {
        if (li.classList.contains('zoom-active')) {
          resetTransform();
        }
      });

      // Når zoom er aktiv: bloker Fancybox så et klik på billedet IKKE åbner lightbox.
      // (Klik på magnifier-knappen toggler off.)
      if (anchorLink) {
        anchorLink.addEventListener('click', function (e) {
          if (li.classList.contains('zoom-active')) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);
      }
    }

    function initAll() {
      document.querySelectorAll('.l4pr > li').forEach(initZoomToggle);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Hvis Shopify-section opdateres i editor: re-init
    document.addEventListener('shopify:section:load', initAll);
  })();


  /* =====================================================================
    THAIBUTIKKEN — "Bladre i kollektion" der RESPEKTERER FILTRERINGEN
    På kollektionssider gemmes den aktuelt viste (filtrerede + sorterede)
    liste af produkter i sessionStorage. På produktsiden vises Forrige/Næste
    ud fra dén liste, så man kan bladre inden for præcis det udvalg man kom fra.
    Begrænsning: kun produkterne på den indlæste side (paginering pr. 48).
    ===================================================================== */
  (function () {
    'use strict';

    var KEY = 'tb_browse_list';
    var LBL = 'tb_browse_label';

    function normUrl(href) {
      if (!href) return '';
      var path = href.split('#')[0].split('?')[0].replace(/^https?:\/\/[^/]+/, '');
      var m = path.match(/\/products\/[^/]+$/); // canonical /products/handle (uden evt. /collections/...-prefix)
      return m ? m[0] : '';
    }

    // På kollektionssiden: gem den viste produkt-rækkefølge
    function captureList() {
      var grid = document.querySelector('.l4cl');
      if (!grid) return;
      var urls = [];
      grid.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        var u = normUrl(a.getAttribute('href'));
        if (u && urls.indexOf(u) === -1) urls.push(u);
      });
      if (urls.length < 2) return; // ikke et reelt grid
      try {
        sessionStorage.setItem(KEY, JSON.stringify(urls));
        var h1 = document.querySelector('h1');
        sessionStorage.setItem(LBL, h1 ? h1.textContent.trim() : '');
      } catch (e) {}
    }

    // På produktsiden: byg Forrige/Næste ud fra den gemte liste
    function buildPager() {
      var raw, list;
      try { raw = sessionStorage.getItem(KEY); } catch (e) { return; }
      if (!raw) return;
      try { list = JSON.parse(raw); } catch (e) { return; }
      if (!list || !list.length) return;

      var here = normUrl(location.pathname);
      var idx = list.indexOf(here);
      if (idx === -1) return; // produktet er ikke i den browsede liste

      var prev = idx > 0 ? list[idx - 1] : null;
      var next = idx < list.length - 1 ? list[idx + 1] : null;
      if (!prev && !next) return;

      var label = '';
      try { label = sessionStorage.getItem(LBL) || ''; } catch (e) {}

      var nav = document.createElement('nav');
      nav.className = 'product-pager tb-browse-pager';
      nav.setAttribute('aria-label', 'Bladre i ' + (label || 'kollektion'));

      var html = '';
      html += prev
        ? '<a href="' + prev + '" rel="prev" title="Forrige produkt"><i aria-hidden="true" class="icon-chevron-left"></i><span>Forrige</span></a>'
        : '<span class="is-disabled" aria-hidden="true"><i class="icon-chevron-left"></i><span>Forrige</span></span>';
      html += '<span class="tb-browse-count">' + (idx + 1) + ' / ' + list.length + '</span>';
      html += next
        ? '<a href="' + next + '" rel="next" title="Næste produkt"><span>Næste</span><i aria-hidden="true" class="icon-chevron-right"></i></a>'
        : '<span class="is-disabled" aria-hidden="true"><span>Næste</span><i class="icon-chevron-right"></i></span>';
      nav.innerHTML = html;

      var bc = document.querySelector('.n6br');
      if (bc && !bc.querySelector('.product-pager')) {
        bc.appendChild(nav);
      } else {
        var art = document.getElementById('main-product');
        if (art && art.parentNode) art.parentNode.insertBefore(nav, art);
      }
    }

    function initBrowse() {
      var b = document.body;
      if (!b) return;
      if (b.classList.contains('template-collection')) captureList();
      if (b.classList.contains('template-product')) buildPager();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBrowse);
    } else {
      initBrowse();
    }
  })();


  /* =====================================================================
    THAIBUTIKKEN — robust "Læs mere" på kollektionsteksten
    Temaets eget read-more-toggle ligger i en async-fil og er upålidelig på
    kollektionssider (klik på <a href="./"> genindlæser bare siden i stedet for
    at folde ud). Vi styrer toggle her: klik folder .m6lm ud/ind via klassen
    .link-more-clicked på .w50 (som vores CSS reagerer på), og blokerer temaets
    handler via capture + stopImmediatePropagation + preventDefault.
    ===================================================================== */
  (function () {
    'use strict';

    function onClick(e) {
      e.preventDefault();
      var target = document.getElementById('tb-coll-fulldesc');
      if (target && target.scrollIntoView) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' }); // blødt scroll = mindst muligt hop
      } else if (target) {
        location.hash = 'tb-coll-fulldesc';
      }
    }

    function wireReadMore() {
      var links = document.querySelectorAll('.tb-coll-scrollmore:not(.tb-rm-wired)');
      for (var i = 0; i < links.length; i++) {
        links[i].classList.add('tb-rm-wired');
        links[i].addEventListener('click', onClick);
      }
    }

    // Vis kun "Læs mere" når der FAKTISK er mere at læse: enten er introen
    // afkortet (overflow), eller den fulde beskrivelse nedenfor er længere
    // end det viste. Ellers skjules linket (så kort tekst ikke får et nytteløst link).
    function refineReadMore() {
      var blocks = document.querySelectorAll('.tb-coll-desc');
      var full = document.getElementById('tb-coll-fulldesc');
      var fullLen = full ? full.textContent.replace(/\s+/g, ' ').trim().length : 0;
      for (var i = 0; i < blocks.length; i++) {
        var link = blocks[i].querySelector('.has-link-more');
        if (!link) continue;
        var intro = blocks[i].querySelector('.m6lm');
        var overflowing = intro && (intro.scrollHeight - intro.clientHeight > 4);
        var introLen = intro ? intro.textContent.replace(/\s+/g, ' ').trim().length : 0;
        var moreBelow = fullLen > introLen + 30;
        link.style.display = (overflowing || moreBelow) ? '' : 'none';
      }
    }

    function runReadMore() { wireReadMore(); refineReadMore(); }

    var rmTimer;
    function refineDebounced() { clearTimeout(rmTimer); rmTimer = setTimeout(refineReadMore, 150); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runReadMore);
    } else {
      runReadMore();
    }
    window.addEventListener('load', refineReadMore);
    window.addEventListener('resize', refineDebounced);
    document.addEventListener('shopify:section:load', runReadMore);
  })();


  /* =====================================================================
    THAIBUTIKKEN — dynamisk "spar"-pris på betingede kampagner (min. antal)
    En automatisk Shopify-rabat (GRAP) viser ikke en før/nu-pris på siden.
    Når kampagne-boksen (.tb-camp--box) har min.antal + type + værdi, og kunden
    vælger nok styk (>= min), streger vi normalprisen over og viser stk-prisen
    efter rabat. Rent visuelt — selve rabatten gives stadig af Shopify i kurven.
    ===================================================================== */
  (function () {
    'use strict';

    function init() {
      var box = document.querySelector('[data-tb-camp]');
      if (!box) return;

      var min = parseInt(box.getAttribute('data-tb-min'), 10) || 0;
      var type = (box.getAttribute('data-tb-type') || '').trim();
      var val = parseFloat((box.getAttribute('data-tb-val') || '0').replace(',', '.')) || 0;
      var base = parseInt(box.getAttribute('data-tb-price'), 10) || 0; // pris i øre

      if (min < 2 || base <= 0) return;
      if (type !== 'pct' && type !== 'belob' && type !== 'fast') return;

      var disc = base;
      if (type === 'pct') disc = Math.round(base * (1 - val / 100));
      else if (type === 'belob') disc = Math.round(base - val * 100);
      else if (type === 'fast') disc = Math.round(val * 100);
      if (disc < 0) disc = 0;
      if (disc >= base) return; // ingen reel besparelse

      var priceEl = document.querySelector('.f8pr-price .tb-price-amount');
      if (!priceEl) return;
      if (!priceEl.getAttribute('data-tb-orig')) priceEl.setAttribute('data-tb-orig', priceEl.innerHTML);
      var orig = priceEl.getAttribute('data-tb-orig');

      var qtyEl = document.querySelector('.f8pr-amount input') ||
                  document.querySelector('#main-product input[name="quantity"]') ||
                  document.querySelector('input[name="quantity"]');

      function money(ore) {
        return (ore / 100).toFixed(2).replace('.', ',') + ' kr';
      }

      var cartQty = 0; // antal af kampagnens varer der allerede ligger i kurven (på tværs)

      function update() {
        var q = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
        if (cartQty + q >= min) {
          priceEl.innerHTML = '<s class="tb-price-old">' + orig + '</s> <span class="tb-price-new">' + money(disc) + '/stk</span>';
        } else {
          priceEl.innerHTML = orig;
        }
      }

      if (qtyEl) {
        qtyEl.addEventListener('change', update);
        qtyEl.addEventListener('input', update);
      }
      update();

      // Kurv-bevidst: tæl kampagnens varer der allerede ligger i kurven (på tværs),
      // så prisen også streges når tærsklen er nået via ANDRE varer i kampagnen.
      var prodsAttr = (box.getAttribute('data-tb-prods') || '').trim();
      if (prodsAttr && window.fetch) {
        var inCamp = {};
        prodsAttr.split(/\s+/).forEach(function (id) { if (id) inCamp[id] = true; });
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            cartQty = 0;
            (cart.items || []).forEach(function (it) {
              if (inCamp[String(it.product_id)]) cartQty += it.quantity;
            });
            update();
          })
          .catch(function () {});
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  /* ===== Favoritter / ønskeseddel (Thai-Butikken, 2026-05-31) =====
    Hjerte på varekort gemmer varen i localStorage (denne enhed).
    Favoritsiden (sektion "tb-favoritter") fyldes herfra. */
  (function () {
    var KEY = 'tb_favs';
    function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
    function has(a, id) { for (var i = 0; i < a.length; i++) { if (String(a[i].id) === String(id)) return true; } return false; }

    function syncHearts() {
      var a = read();
      Array.prototype.forEach.call(document.querySelectorAll('[data-tb-fav]'), function (b) {
        var on = has(a, b.getAttribute('data-id'));
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('title', on ? 'Fjern fra favoritter' : 'Gem som favorit');
      });
    }

    function updateCount() {
      var n = read().length;
      Array.prototype.forEach.call(document.querySelectorAll('[data-tb-fav-count]'), function (el) {
        el.textContent = n;
        el.hidden = (n === 0);
      });
    }

    function renderList() {
      var wrap = document.querySelector('[data-tb-fav-list]');
      if (!wrap) return;
      var a = read();
      var empty = document.querySelector('[data-tb-fav-empty]');
      if (empty) empty.hidden = (a.length > 0);
      wrap.innerHTML = '';
      a.forEach(function (x) {
        var li = document.createElement('li');
        li.className = 'tb-favcard';
        var img = '<span class="tb-favcard__imgwrap">' + (x.img ? '<img class="tb-favcard__img" src="' + x.img + '" alt="" loading="lazy">' : '') + '</span>';
        var price = x.price ? '<span class="tb-favcard__price">' + x.price + '</span>' : '';
        li.innerHTML =
          '<a class="tb-favcard__link" href="' + x.url + '">' + img +
          '<span class="tb-favcard__title">' + x.title + '</span>' + price + '</a>' +
          '<button type="button" class="tb-favcard__rm" data-tb-fav data-id="' + x.id + '" aria-label="Fjern fra favoritter">Fjern ✕</button>';
        wrap.appendChild(li);
      });
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-tb-fav]') : null;
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      var a = read();
      var id = b.getAttribute('data-id');
      if (has(a, id)) {
        a = a.filter(function (x) { return String(x.id) !== String(id); });
      } else {
        a.push({
          id: id,
          title: b.getAttribute('data-title') || '',
          url: b.getAttribute('data-url') || '#',
          img: b.getAttribute('data-img') || '',
          price: b.getAttribute('data-price') || ''
        });
      }
      write(a);
      syncHearts();
      updateCount();
      renderList();
    });

    function initFav() { syncHearts(); updateCount(); renderList(); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFav);
    } else {
      initFav();
    }
    document.addEventListener('shopify:section:load', initFav);
  })();

  /* ===== Visnings-skifter (Standard / Bred / Liste) — additiv, 2026-06-01 =====
    Injicerer en knaprække over produktgridet på kollektions-/søgesider.
    Skifter en klasse på .collection-wrapper + bruger temaets egen .list-stil.
    Standard-visningen (ingen klasse) røres ALDRIG. Valget huskes pr. enhed. */
  (function () {
    var ICONS = {
      standard: '<svg viewBox="0 0 20 20" width="18" height="18" fill="currentColor" aria-hidden="true"><rect x="1" y="1" width="8" height="8" rx="1.5"/><rect x="11" y="1" width="8" height="8" rx="1.5"/><rect x="1" y="11" width="8" height="8" rx="1.5"/><rect x="11" y="11" width="8" height="8" rx="1.5"/></svg>',
      wide: '<svg viewBox="0 0 20 20" width="18" height="18" fill="currentColor" aria-hidden="true"><rect x="1" y="3" width="3.2" height="14" rx="1"/><rect x="5.6" y="3" width="3.2" height="14" rx="1"/><rect x="10.2" y="3" width="3.2" height="14" rx="1"/><rect x="14.8" y="3" width="3.2" height="14" rx="1"/></svg>',
      list: '<svg viewBox="0 0 20 20" width="18" height="18" fill="currentColor" aria-hidden="true"><rect x="1" y="2.5" width="18" height="3" rx="1"/><rect x="1" y="8.5" width="18" height="3" rx="1"/><rect x="1" y="14.5" width="18" height="3" rx="1"/></svg>'
    };
    var LABELS = { standard: 'Standard visning', wide: 'Bred visning', list: 'Liste visning' };
    var KEY = 'tb_coll_view';

    function init() {
      return; /* Visnings-skifter slaaet fra 2026-06-01 - var utestet + virkede ikke; laves ordentligt med browser-test senere */
      var grid = document.getElementById('collection');
      if (!grid) return;
      var wrap = (grid.closest && grid.closest('.collection-wrapper')) || grid.parentNode;
      if (!wrap) return;

      var saved = 'standard';
      try { saved = localStorage.getItem(KEY) || 'standard'; } catch (e) {}

      function apply(v) {
        if (v !== 'wide' && v !== 'list') v = 'standard';
        wrap.classList.remove('tb-view-standard', 'tb-view-wide', 'tb-view-list');
        wrap.classList.add('tb-view-' + v);
        grid.classList.toggle('list', v === 'list');
        var bar = wrap.querySelector('.tb-viewbar');
        if (bar) Array.prototype.forEach.call(bar.querySelectorAll('[data-tbview]'), function (b) {
          var on = b.getAttribute('data-tbview') === v;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      if (!wrap.querySelector('.tb-viewbar')) {
        var bar = document.createElement('div');
        bar.className = 'tb-viewbar';
        bar.setAttribute('role', 'group');
        bar.setAttribute('aria-label', 'Skift produktvisning');
        var html = '';
        ['standard', 'wide', 'list'].forEach(function (v) {
          html += '<button type="button" class="tb-viewbtn" data-tbview="' + v + '" title="' + LABELS[v] + '" aria-label="' + LABELS[v] + '">' + ICONS[v] + '</button>';
        });
        bar.innerHTML = html;
        grid.parentNode.insertBefore(bar, grid);
        bar.addEventListener('click', function (e) {
          var b = e.target.closest ? e.target.closest('[data-tbview]') : null;
          if (!b) return;
          var v = b.getAttribute('data-tbview');
          try { localStorage.setItem(KEY, v); } catch (err) {}
          apply(v);
        });
      }
      apply(saved);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  /* =====================================================================
    THAIBUTIKKEN — "Læg i kurv" fra opskrift-køb-blokken (.tb-shop-add)
    Feedback på knappen + åbner kurv-skuffen kort (auto-lukker ~5s, hover-venlig).
    Bruger temaets egne globale kurv-funktioner (updateCartPanel/hidePanels).
    ===================================================================== */
  (function () {
    'use strict';
    if (window.__tbShopAddBound) return;
    window.__tbShopAddBound = true;

    var cartTimer;

    // Åbn skuffen (og hent dens indhold friskt, så den nye vare vises)
    function openCart() {
      if (typeof window.updateCartPanel === 'function') { try { window.updateCartPanel(false, true, false, true); return true; } catch (e) {} }
      if (typeof window.showCartPanel === 'function') { try { window.showCartPanel(); return true; } catch (e) {} }
      var t = document.querySelector('a[data-panel="cart"]');
      if (t) { t.click(); return true; }
      return false;
    }

    // Luk skuffen via temaets egne funktioner (fallback: klik luk-knappen)
    function closeCart() {
      if (typeof window.hidePanels === 'function') { try { window.hidePanels(); return; } catch (e) {} }
      if (typeof window.overlayClose === 'function') { try { window.overlayClose(); return; } catch (e) {} }
      var c = document.querySelector('.m6pn-open .m6pn-close, #cart .m6pn-close');
      if (c) c.click();
    }

    // Auto-luk efter ~5s — men hold åben mens musen er over skuffen
    function closeCartSoon() {
      clearTimeout(cartTimer);
      cartTimer = setTimeout(function tick() {
        var d = document.getElementById('cart');
        if (d && d.matches && d.matches(':hover')) { cartTimer = setTimeout(tick, 1500); return; }
        closeCart();
      }, 5000);
    }

    // Gælder ENHVER åbning af kurv-skuffen (også temaets egen add-to-cart fra vareoversigten)
    window.addEventListener('themeCartOpened', closeCartSoon);

    // Lille "Tilføjet til kurven"-boble ved knappen (forsvinder efter ~2s) — i stedet for
    // at skifte teksten inde i den lille runde "+"-knap (som så lidt klemt ud).
    function tbShopToast(btn, msg, isError) {
      var row = (btn.closest && btn.closest('.tb-shop-item')) || btn.parentNode;
      if (!row) return;
      var t = document.createElement('span');
      t.className = 'tb-shop-toast' + (isError ? ' tb-shop-toast--error' : '');
      t.textContent = msg;
      row.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('show'); });
      setTimeout(function () {
        t.classList.remove('show');
        setTimeout(function () { if (t.parentNode) { t.parentNode.removeChild(t); } }, 240);
      }, 1900);
    }

    // Sekventiel kø: hvert klik laegger +1 i kurven. INGEN laasning -> man kan trykke flere
    // gange og bestille dobbelt. Koeen serialiserer kaldene, saa hurtige klik ikke racer paa
    // kurv-token'et (ingen "kun den foerste").
    var tbAddQueue = Promise.resolve();
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.tb-shop-add') : null;
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant');
      if (!id) return;
      btn.classList.add('is-loading');
      tbShopToast(btn, 'Tilføjet til kurven');     // kvittering paa HVERT klik
      tbAddQueue = tbAddQueue
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          });
        })
        .then(function (r) { return (r && r.ok) ? r.json() : null; })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-done');
          setTimeout(function () { btn.classList.remove('is-done'); }, 700);
          // Live-opdater kurv-tal + skuffe-indhold UDEN at aabne skuffen: intet overlay -> man kan
          // klikke "+" igen med det samme, og man behoever ikke F5 for at se kurven opdateret.
          if (typeof window.updateCartPanel === 'function') {
            try { window.updateCartPanel(false, false, false, true); return; } catch (e) {}
          }
          return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
            .then(function (r) { return r.json(); })
            .then(function (cart) { document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; }); });
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          tbShopToast(btn, 'Prøv igen', true);
        });
    });
  })();

  /* =====================================================================
     Skjul "Senest sete varer"-sektionen hvis den er tom (ingen viste varer
     endnu, fx ved foerste besoeg). Temaet fylder listen async fra localStorage;
     vi tjekker ved load, lytter efter sen-population og har en fallback-timer.
     ===================================================================== */
  (function () {
    'use strict';
    function syncEmpty() {
      document.querySelectorAll('.recently-viewed-products').forEach(function (sec) {
        var grid = sec.querySelector('.l4cl');
        if (!grid) return;
        var has = grid.querySelector('li, .product-item, a[href*="/products/"]');
        var wrap = sec.closest('.shopify-section') || sec;
        wrap.style.display = has ? '' : 'none';
      });
    }
    function init() {
      syncEmpty();
      document.querySelectorAll('.recently-viewed-products .l4cl').forEach(function (grid) {
        try { new MutationObserver(syncEmpty).observe(grid, { childList: true }); } catch (e) {}
      });
      setTimeout(syncEmpty, 1200);
      setTimeout(syncEmpty, 3000);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  /* =====================================================================
     Dynamisk produkt-antal i tekster. Skriv [antalvare] eller [antalvare+] i en
     hvilken som helst editor-tekst -> erstattes med fx "3.000" / "3.000+".
     Tallet kommer server-side fra footer-bjaelken (data-tb-antal), saa det
     altid er korrekt og rundet ned til naermeste 500. Se snippet 'tb-antal'.
     ===================================================================== */
  (function () {
    'use strict';
    function fillTokens() {
      var src = document.querySelector('[data-tb-antal]');
      if (!src) return;
      var val = (src.getAttribute('data-tb-antal') || '').trim();
      if (!val) return;
      var valPlus = (src.getAttribute('data-tb-antalplus') || (val + '+')).trim();
      if (document.body.textContent.indexOf('[antalvare') === -1) return;
      var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
      var hits = [], n;
      while ((n = walker.nextNode())) {
        if (n.nodeValue && n.nodeValue.indexOf('[antalvare') !== -1) hits.push(n);
      }
      hits.forEach(function (node) {
        node.nodeValue = node.nodeValue
          .replace(/\[antalvare\+\]/g, valPlus)
          .replace(/\[antalvare\]/g, val);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fillTokens);
    } else {
      fillTokens();
    }
  })();
